import React from 'react';
import { Box } from '@mui/material';
import CadStockStatusLabel from './CadStockStatusLabel';
import { getCadStockColor } from '../utils/cadStockStatus';
import { withAlpha } from '../../Map/utils/sharedBranding';

/**
 * Badge de estado de stock (Disponible / Reservado / Vendido…): reusa
 * `CadStockStatusLabel` (puntito + label del share) dentro de una pastilla
 * teñida con el color del estado. Para destacar el estado en modo lectura.
 * @param {object} props
 * @param {string} [props.status]
 */
export default function StockStatusBadge({ status }) {
  const resolved = status || 'available';
  const color = getCadStockColor(resolved);
  return (
    <Box
      component="span"
      data-testid="stock-status-badge"
      data-status={resolved}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        px: 1,
        height: 24,
        borderRadius: '12px',
        bgcolor: withAlpha(color, 0.18),
        border: `1px solid ${withAlpha(color, 0.5)}`,
        color: '#EDEDED',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: 1,
      }}
    >
      <CadStockStatusLabel status={resolved} />
    </Box>
  );
}
